const getDisplayMedicineList = () => {
  const envValue = process.env.REACT_APP_HPGP_DISPLAY_MEDICINES;

  if (!envValue) {
    return null;
  }

  return envValue.split(',').map(item => item.trim()).filter(item => item !== '');
};

export default getDisplayMedicineList;
